// Michael Jackson Songs card game data with rankings
export const MJ_SONGS_CARDS = [
  { id: 1, name: "Man in the Mirror", rank: 1, image: "/images/mjSongs/mjSongs_1.jpg" },
  { id: 2, name: "Rock with You", rank: 2, image: "/images/mjSongs/mjSongs_2.jpg" },
  { id: 3, name: "Don't Stop 'Til You Get Enough", rank: 3, image: "/images/mjSongs/mjSongs_3.jpg" },
  { id: 4, name: "Billie Jean", rank: 4, image: "/images/mjSongs/mjSongs_4.jpg" },
  { id: 5, name: "Beat It", rank: 5, image: "/images/mjSongs/mjSongs_5.jpg" },
  { id: 6, name: "Thriller", rank: 6, image: "/images/mjSongs/mjSongs_6.jpg" },
  { id: 7, name: "Bad", rank: 7, image: "/images/mjSongs/mjSongs_7.jpg" },
  { id: 8, name: "The Way You Make Me Feel", rank: 8, image: "/images/mjSongs/mjSongs_8.jpg" },
  { id: 9, name: "Smooth Criminal", rank: 9, image: "/images/mjSongs/mjSongs_9.jpg" },
  { id: 10, name: "Black or White", rank: 10, image: "/images/mjSongs/mjSongs_10.jpg" },
  { id: 11, name: "Dirty Diana", rank: 11, image: "/images/mjSongs/mjSongs_11.jpg" },
  { id: 12, name: "Ben", rank: 12, image: "/images/mjSongs/mjSongs_12.jpg" },
  { id: 13, name: "The Girl is Mine", rank: 13, image: "/images/mjSongs/mjSongs_13.jpg" },
  { id: 14, name: "Remember the Time", rank: 14, image: "/images/mjSongs/mjSongs_14.jpg" },
  { id: 15, name: "You Are Not Alone", rank: 15, image: "/images/mjSongs/mjSongs_15.jpg" },
  { id: 16, name: "P.Y.T", rank: 16, image: "/images/mjSongs/mjSongs_16.jpg" },
  { id: 17, name: "Will You Be There", rank: 17, image: "/images/mjSongs/mjSongs_17.jpg" },
  { id: 18, name: "Wanna Be Startin' Something", rank: 18, image: "/images/mjSongs/mjSongs_18.jpg" },
  { id: 19, name: "Dangerous", rank: 19, image: "/images/mjSongs/mjSongs_19.jpg" },
  { id: 20, name: "She's Out of My Life", rank: 20, image: "/images/mjSongs/mjSongs_20.jpg" },
  { id: 21, name: "Say Say Say", rank: 21, image: "/images/mjSongs/mjSongs_21.jpg" },
  { id: 22, name: "Human Nature", rank: 22, image: "/images/mjSongs/mjSongs_22.jpg" },
  { id: 23, name: "I Just Can't Stop Loving You", rank: 23, image: "/images/mjSongs/mjSongs_23.jpg" },
  { id: 24, name: "Leave Me Alone", rank: 24, image: "/images/mjSongs/mjSongs_24.jpg" },
  { id: 25, name: "They Don't Care About Us", rank: 25, image: "/images/mjSongs/mjSongs_25.jpg" },
  { id: 26, name: "In the Closet", rank: 26, image: "/images/mjSongs/mjSongs_26.jpg" },
  { id: 27, name: "Scream", rank: 27, image: "/images/mjSongs/mjSongs_27.jpg" },
  { id: 28, name: "You Rock My World", rank: 28, image: "/images/mjSongs/mjSongs_28.jpg" },
  { id: 29, name: "Heal the World", rank: 29, image: "/images/mjSongs/mjSongs_29.jpg" },
  { id: 30, name: "Got to Be There", rank: 30, image: "/images/mjSongs/mjSongs_30.jpg" }
];
